/**
 * cal-popup.js
 *
 * Opens Cal.com booking links in Cal's pop-up instead of navigating away. Any
 * <a> whose href starts with https://cal.com/ or https://app.cal.com/ is picked
 * up; data-cal-popup="false" on the link opts it out. A page with no such link
 * loads nothing.
 *
 * The href is left as it is and is the fallback: until Cal's embed.js has
 * loaded (or when it fails to load), a click is an ordinary link to cal.com.
 * Once it has loaded, the click is cancelled here and Cal's own delegated
 * [data-cal-link] handler opens the modal. That handler never cancels the
 * navigation itself, so without the preventDefault an <a> would do both.
 *
 * The brand colour is this script tag's data-brand-color (layout/theme.liquid:
 * the first colour scheme's primary button background). The injected embed.js
 * carries data-cookieconsent="ignore" so Cookiebot's auto-blocking leaves it be.
 */
(function () {
  'use strict';

  if (window.lvCalPopup) return;
  window.lvCalPopup = true;

  var EMBED_SRC = 'https://app.cal.com/embed/embed.js';
  var ORIGIN = 'https://app.cal.com';
  var SELECTOR = 'a[href^="https://cal.com/"], a[href^="https://app.cal.com/"]';
  var CONFIG = '{"layout":"month_view","theme":"light"}';

  // document.currentScript is only set while this file runs, not in callbacks.
  var script = document.currentScript;
  var brand = script ? (script.getAttribute('data-brand-color') || '').trim() : '';

  var ready = false;
  var bound = new WeakSet();
  var namespaces = {};

  // Cal's loader, from the event type's Embed > "Element click" snippet. The one
  // change: the <script> gets data-cookieconsent and a load listener before it is
  // inserted, where the original appends it and sets src afterwards.
  function installLoader() {
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          let s = d.createElement('script');
          s.src = A;
          s.setAttribute('data-cookieconsent', 'ignore');
          s.addEventListener('load', function () { ready = true; });
          d.head.appendChild(s);
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, EMBED_SRC, 'init');
  }

  function setUpNamespace(ns, calLink) {
    if (namespaces[ns]) return;
    namespaces[ns] = true;

    var ui = { theme: 'light', layout: 'month_view', hideEventTypeDetails: false };
    if (brand) ui.styles = { branding: { brandColor: brand } };

    window.Cal('init', ns, { origin: ORIGIN });
    window.Cal.ns[ns]('ui', ui);
    window.Cal.ns[ns]('preload', { calLink: calLink });
  }

  function onClick(event) {
    if (ready) event.preventDefault();
  }

  function init() {
    var found = [];
    var links = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (bound.has(link) || link.getAttribute('data-cal-popup') === 'false') continue;

      var url;
      try {
        url = new URL(link.href);
      } catch (e) {
        continue;
      }

      // https://cal.com/lavilahome.com/30min -> lavilahome.com/30min, namespace 30min
      var calLink = url.pathname.replace(/^\/+|\/+$/g, '');
      if (!calLink) continue;
      var ns = calLink.split('/').pop().toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '') || 'cal';

      link.setAttribute('data-cal-link', calLink);
      link.setAttribute('data-cal-namespace', ns);
      link.setAttribute('data-cal-config', CONFIG);
      link.addEventListener('click', onClick);
      bound.add(link);
      found.push([ns, calLink]);
    }

    if (!found.length) return;
    if (!window.Cal) installLoader();
    for (var j = 0; j < found.length; j++) setUpNamespace(found[j][0], found[j][1]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: sections re-render in place, so pick up any new Cal links.
  document.addEventListener('shopify:section:load', init);
})();
